import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { AIDisclosureResultService } from '@/services/ai-disclosure/service/ai-disclosure-result.service';
import { ref } from 'vue';
import { createSharedComposable } from '@vueuse/core';
import type { AIDisclosureResultState } from '@/services/ai-disclosure/type/ai-disclosure.type';
import { useDisposes } from '@/composables/use-disposes';

export const useAiDisclosureResult = createSharedComposable(() => {
    const aiDisclosureResultService = injectService<AIDisclosureResultService>(AIDisclosureResultService);
    const aiDisclosureResultData = ref<AIDisclosureResultState>(aiDisclosureResultService.getModelData());

    const updateState = (states: AIDisclosureResultState) => {
        aiDisclosureResultData.value = states;
    };

    aiDisclosureResultService.onStatesChange(updateState);

    const { disposes } = useDisposes();
    disposes.push(
        aiDisclosureResultService.onStatesChange(updateState)
    );

    return {
        aiDisclosureResultService,
        aiDisclosureResultData,
    };
});
